import React, { useEffect, useContext, useCallback } from 'react';
import { FLEET_TAB } from 'modules/fleet/events';

import { SegmentedButton } from '@ontruck/orc';

import DispatchingFiltersContext from 'modules/dispatching/filters/context';
import { useSelector } from 'react-redux';
import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';

const filterWidth = (width) => ({ style: { minWidth: width, maxWidth: width } });

const DispatchingFilters = () => {
  const { filters, setFilters } = useContext(DispatchingFiltersContext);
  const isAutomaticEnabled = useSelector((state) =>
    getSpecificClientConfig(state, constants.AUTOMATIC)
  );

  const handleNeedManualDispatchingChange = useCallback(
    (e) => {
      setFilters((oldFilters) => ({
        ...oldFilters,
        need_manual_dispatching: e.target.value === 'true',
      }));
    },
    [setFilters]
  );

  useEffect(() => {
    if (isAutomaticEnabled) FLEET_TAB.APPLY_FILTER(filters);
  }, [filters, isAutomaticEnabled]);

  if (!isAutomaticEnabled) return <></>;

  return (
    <>
      <div className="filter" {...filterWidth('100px')} data-testid="shipperFilter">
        <SegmentedButton.Parent
          size="M"
          name="need_manual_dispatching"
          value={filters?.need_manual_dispatching}
          onChange={handleNeedManualDispatchingChange}
        >
          <SegmentedButton.Child value={true} label="Manual" />
          <SegmentedButton.Child value={false} label="Auto" />
        </SegmentedButton.Parent>
      </div>
    </>
  );
};

export default DispatchingFilters;
